import React from "react";
import { IconButton } from "../icon-button";
import { useIsOverviewMode } from "../../hooks/useIsOverviewMode";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { useDefinition } from "../../hooks/useDefinition";

export function useSpreadOverviewButton() {
	const [, setIsOverviewMode] = useIsOverviewMode();
	const googleAnalytics = useGoogleAnalytics();

	const definition = useDefinition();
	const showSpreadOverviewButton =
		definition?.canManipulateSpreads() || (definition && definition.spreads.length > 1);

	const onClick = () => {
		googleAnalytics.trackEventToGa({
			trackingAction: "OverviewClicked",
		});
		setIsOverviewMode(true);
	};

	return showSpreadOverviewButton
		? ({
				iconName: "spread-overview",
				onClick,
		  } as const)
		: undefined;
}

/** returns null if user cannot manipulate spreads */
export const SpreadOverviewButton = () => {
	const overViewProps = useSpreadOverviewButton();
	if (!overViewProps) return null;

	return <IconButton {...overViewProps} elevated />;
};
